export var OASIS;
(function (OASIS) {
    OASIS["SOC"] = "01";
    OASIS["ROC"] = "03";
    OASIS["RCT"] = "04";
    OASIS["OFU"] = "05";
    OASIS["TR"] = "06";
    OASIS["TRD"] = "07";
    OASIS["DTH"] = "08";
    OASIS["DSCH"] = "09";
})(OASIS || (OASIS = {}));
